//buttons and color
document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("viewer-3d-overlay");
  const openBtn = document.querySelector(".view-3d-overlay-btn");
  const closeBtn = document.getElementById("close-3d");
  const selectedColor = document.getElementById("selected-color");

  if (!overlay || !openBtn) return;

  openBtn.addEventListener("click", () => {
    overlay.hidden = false;
    document.body.style.overflow = "hidden";
  });

  closeBtn.addEventListener("click", () => {
    overlay.hidden = true;
    document.body.style.overflow = "";
  });

  document.querySelectorAll(".color-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      selectedColor.textContent = btn.dataset.color;
    });
  });
});

//for   qr   generation

document.addEventListener("DOMContentLoaded", () => {
  const qrImg = document.getElementById("ar-qr");
  if (!qrImg) return;

  // Use current product page URL
  const pageUrl = window.location.href.split('?')[0]+ '?open3d=true';

  qrImg.src =
    'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' +
    encodeURIComponent(pageUrl);
    console.log(qrImg.src);
});

//auto open ar on mobile
document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const shouldOpenAR = params.get("open3d");

  if (!shouldOpenAR) return;

  const isMobile =
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (!isMobile) return;

  const modelViewer = document.querySelector("model-viewer");

  if (!modelViewer) return;

  // Wait for model-viewer to be ready
//   modelViewer.addEventListener("load", () => {
//     setTimeout(() => {
//       modelViewer.enterAR();
//     }, 500);
//   });
});

// ===============================
// 1. LOAD MODEL FROM QR PARAM
// ===============================
document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const modelFromQR = params.get("model");

  const modelViewer = document.getElementById("product-model-viewer");
  if (!modelViewer || !modelFromQR) return;

  let modelUrl = decodeURIComponent(modelFromQR);

  // Fix protocol-relative URLs
  if (modelUrl.startsWith("//")) {
    modelUrl = "https:" + modelUrl;
  }

  console.log("🎯 Model loaded from QR:", modelUrl);

  // Load correct model before AR starts
  modelViewer.src = modelUrl;
});


// Auto open 3D overlay + Auto open AR (IKEA style)
document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  if (!params.get("open3d")) return;

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isMobile = isAndroid || isIOS;
  if (!isMobile) return;

  const overlay = document.getElementById("viewer-3d-overlay");
  const modelViewer = document.getElementById("product-model-viewer");
  if (!overlay || !modelViewer) return;

  // 1. Open your 3D overlay UI
  overlay.hidden = false;
  document.body.style.overflow = "hidden";

  // let modelUrl = modelViewer.getAttribute("src");
  let modelUrl = modelViewer.src;

  // Fix protocol relative URL
  if (modelUrl.startsWith("//")) {
    modelUrl = "https:" + modelUrl;
  }

  if (!modelUrl) {
    alert("Model URL is missing!");
    return;
  }
  
  // 2. Launch native AR automatically (IKEA style)
  setTimeout(() => {

    // ANDROID → Scene Viewer
    if (isAndroid) {
      const intentUrl =
        `intent://arvr.google.com/scene-viewer/1.0` +
        `?file=${encodeURIComponent(modelUrl)}` +
        `&mode=ar_only` +
        `#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;end;`;

      window.location.href = intentUrl;
    }

    // iOS → Quick Look (requires USDZ file)
    // if (isIOS) {
    //   const usdzUrl = modelUrl.replace(".glb", ".usdz");
    //   window.location.href = usdzUrl;
    // }
      
      modelViewer.activateAR();

  }, 500);
});

document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".ar-toggle");
  const content = document.querySelector(".ar-content");

  if (!toggle || !content) return;

  toggle.addEventListener("click", () => {
    const isOpen = !content.hasAttribute("hidden");

    content.toggleAttribute("hidden", isOpen);
    toggle.classList.toggle("active", !isOpen);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const modelViewer = document.getElementById("product-model-viewer");
  if (!modelViewer) return;

  document.querySelectorAll(".color-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      // Convert data-color to match data-* attribute in <model-viewer>
      const key = btn.dataset.color
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "_")  // ✅ use underscore, not dash
        .replace(/[^a-z0-9_]/g, ""); 

      const modelUrl = modelViewer.dataset[key];

      if (!modelUrl) {
        console.warn("❌ No model for:", key);
        return;
      }

      // Update active button style
      document.querySelectorAll(".color-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      // Update selected color text
      const selectedColor = document.getElementById("selected-color");
      if (selectedColor) selectedColor.textContent = btn.dataset.color;
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const selectedColor = document.getElementById("selected-color");
  const modelViewer = document.getElementById("product-model-viewer");
  const firstColorBtn = document.querySelector(".color-btn");

  if (!selectedColor || !modelViewer || !firstColorBtn) return;

  // Prevent overriding if already set (safety)
  if (selectedColor.textContent.trim() !== "") return;

  // 1️⃣ Set default color text
  selectedColor.textContent = firstColorBtn.dataset.color;

  // 2️⃣ Set active state
  firstColorBtn.classList.add("active");

  // 3️⃣ Load correct default model
  const key = firstColorBtn.dataset.color
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");

  const modelUrl = modelViewer.dataset[key];
  if (modelUrl) {
    modelViewer.src = modelUrl;
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const modelViewer = document.getElementById("product-model-viewer");
  const selectedColor = document.getElementById("selected-color");
  const buttons = document.querySelectorAll(".color-btn");

  if (!modelViewer || !buttons.length) return;

  function loadModel(btn) {
    const key = btn.dataset.color
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_"); // ✅ MUST match data-australian, data-monalisa

    const modelUrl = modelViewer.dataset[key];

    if (!modelUrl) {
      console.warn("❌ No model found for:", key);
      return;
    }

    modelViewer.src = modelUrl;

     // 🔥 Update QR for this model
    updateQR(modelUrl);

    buttons.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");

    if (selectedColor) {
      selectedColor.textContent = btn.dataset.color;
    }

    // 🔵 Live JS debug
  // document.getElementById("js-debug-url").textContent =
  //   "JS MODEL URL: " + modelUrl;

  console.log("Selected model:", modelUrl);

  // 🔥 Regenerate QR for this model
  // updateQR(modelViewer.getAttribute("src"));
  }

  // ✅ default load (first button)
  loadModel(buttons[0]);

  // ✅ clicks
  buttons.forEach(btn => {
    btn.addEventListener("click", () => loadModel(btn));
  });
});



function updateQR(modelUrl) {
  const qrImg = document.getElementById("ar-qr");
  if (!qrImg) return;

  // Fix protocol-relative URLs
  if (modelUrl.startsWith("//")) {
    modelUrl = "https:" + modelUrl;
  }

  // Build AR deep link page URL with model
  // const pageUrl =
  //   window.location.origin +
  //   window.location.pathname +
  //   "?open3d=true&model=" +
  //   encodeURIComponent(modelUrl);

  // qrImg.src =
  //   "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=" +
  //   encodeURIComponent(pageUrl);

  // console.log("📌 QR updated with:", pageUrl);
  const baseUrl = window.location.href.split("?")[0];

  // 🔥 Send model URL inside QR
  const qrUrl =
    `${baseUrl}?open3d=true&model=${encodeURIComponent(modelUrl)}`;

  qrImg.src =
    "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=" +
    encodeURIComponent(qrUrl);

  console.log("📦 QR updated with model:", modelUrl);
}



//dimensions button
const viewer = document.getElementById('product-model-viewer');
const panel = document.getElementById('measurementPanel');
const toggleBtn = document.getElementById('measurementToggle');
let panelVisible = false;

function updateDimensions() {
  if (!viewer || !viewer.getDimensions) return;
  const size = viewer.getDimensions();
  if (!size) return;
  document.getElementById('dimWidth').textContent = (size.x * 100).toFixed(1);
  document.getElementById('dimHeight').textContent = (size.y * 100).toFixed(1);
  document.getElementById('dimDepth').textContent = (size.z * 100).toFixed(1);
}

toggleBtn.addEventListener('click', () => {
  panelVisible = !panelVisible;
  panel.style.display = panelVisible ? 'block' : 'none';
  toggleBtn.textContent = panelVisible ? 'Hide dimensions' : 'Show dimensions';
});

viewer.addEventListener('load', updateDimensions);


//arrows
//const viewer = document.getElementById('product-model-viewer');
// ================================
// HELPERS
// ================================
const widthLabel = document.getElementById('widthLabel');
const heightLabel = document.getElementById('heightLabel');
const depthLabel = document.getElementById('depthLabel');

function m(v) { return `${v.toFixed(3)}m`; }

// Create or update a hotspot
function setHotspot(name, pos) {
  let el = viewer.querySelector(`[slot="${name}"]`);
  if (!el) {
    el = document.createElement('button');
    el.className = 'hotspot';
    el.slot = name;
    viewer.appendChild(el);
  }
  el.dataset.position = `${m(pos.x)} ${m(pos.y)} ${m(pos.z)}`;
  el.dataset.normal = '0 1 0';
}

// Generate hotspots from bounding box
function generateDimensionHotspots() {
  const size = viewer.getDimensions();
  if (!size) return;

  const min = { x: -size.x/2, y: 0, z: -size.z/2 };
  const max = { x: size.x/2, y: size.y, z: size.z/2 };
  const OFFSET = size.y * 0.05;

  // WIDTH
  setHotspot('hotspot-width-start', { x:min.x, y:max.y+OFFSET, z:max.z });
  setHotspot('hotspot-width-end',   { x:max.x, y:max.y+OFFSET, z:max.z });

  // HEIGHT
  setHotspot('hotspot-height-start',{ x:max.x+OFFSET, y:min.y, z:max.z });
  setHotspot('hotspot-height-end',  { x:max.x+OFFSET, y:max.y, z:max.z });

  // DEPTH
  setHotspot('hotspot-depth-start', { x:max.x, y:max.y+OFFSET, z:min.z });
  setHotspot('hotspot-depth-end',   { x:max.x, y:max.y+OFFSET, z:max.z });

  console.log('📐 Hotspots generated from dimensions');
}

// Get 2D canvas position of a hotspot
function getHotspotCanvasPosition(name) {
  const el = viewer.querySelector(`[slot="${name}"]`);
  if (!el) return null;
  const r = el.getBoundingClientRect();
  const vr = viewer.getBoundingClientRect();
  return {
    x: r.left - vr.left + r.width/2,
    y: r.top - vr.top + r.height/2
  };
}


// Draw a line between two points
function placeLine(line, a, b) {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const length = Math.hypot(dx, dy);
  const angle = Math.atan2(dy, dx);

  line.style.width = `${length}px`;
  line.style.left = `${a.x}px`;
  line.style.top  = `${a.y}px`;
  line.style.transformOrigin = '0 50%';
  line.style.transform = `rotate(${angle}rad)`;

  const label = line.querySelector('span');
  if(label) 
    {
      // place label at exact center of the line
      label.style.left = '50%';
      label.style.top = '50%';
      // label.style.left = `${length / 2}px`;
      // label.style.top = `0px`;
      label.style.transform = `
      translate(-50%, -50%)
      rotate(${-angle}rad)
    `;
    }
}

// Draw all dimensions
function drawDimension(start, end, lineId) {
  const line = document.getElementById(lineId);
  if(!line) return;
  const a = getHotspotCanvasPosition(start);
  const b = getHotspotCanvasPosition(end);
  if(!a || !b) return;
  placeLine(line, a, b);
}

function updateLines() {
  drawDimension('hotspot-width-start',  'hotspot-width-end',  'widthLine');
  drawDimension('hotspot-height-start', 'hotspot-height-end', 'heightLine');
  drawDimension('hotspot-depth-start',  'hotspot-depth-end',  'depthLine');
}

function cmToInches(cm) {
  return cm / 2.54;
}

// Convert decimal inches to fraction (nearest 1/8)
function toFraction(inches) {
  const whole = Math.floor(inches);
  const frac = inches - whole;
  const eighths = Math.round(frac * 8);

  if (eighths === 0) return `${whole}"`;
  if (eighths === 8) return `${whole + 1}"`;

  const gcd = (a, b) => b ? gcd(b, a % b) : a;
  const g = gcd(eighths, 8);

  return `${whole} ${eighths / g}/${8 / g}"`;
}

// Update labels
function updateLabels() {
  const size = viewer.getDimensions();
  if(!size) return;

  const widthCm  = size.x * 100;
  const heightCm = size.y * 100;
  const depthCm  = size.z * 100;

  const widthIn  = cmToInches(widthCm);
  const heightIn = cmToInches(heightCm);
  const depthIn  = cmToInches(depthCm);

  // widthLabel.textContent  = `${(size.x*100).toFixed(0)} cm`;
  // heightLabel.textContent = `${(size.y*100).toFixed(0)} cm`;
  // depthLabel.textContent  = `${(size.z*100).toFixed(0)} cm`;
  widthLabel.textContent  = `${widthCm.toFixed(0)} cm (${toFraction(widthIn)})`;
  heightLabel.textContent = `${heightCm.toFixed(0)} cm (${toFraction(heightIn)})`;
  depthLabel.textContent  = `${depthCm.toFixed(0)} cm (${toFraction(depthIn)})`;
}

// RAF loop for dynamic updates
let rafId = null;
function startAutoUpdate() {
  if(rafId) return;
  const loop = () => {
    updateLines();
    rafId = requestAnimationFrame(loop);
  };
  loop();
}
function stopAutoUpdate() {
  cancelAnimationFrame(rafId);
  rafId = null;
}

// EVENTS
viewer.addEventListener('load', () => {
  generateDimensionHotspots();
  updateLines();
  updateLabels();
  startAutoUpdate();
});
viewer.addEventListener('camera-change', updateLines);
window.addEventListener('resize', updateLines);
viewer.addEventListener('pointerdown', stopAutoUpdate);
viewer.addEventListener('pointerup', startAutoUpdate);

document.addEventListener("DOMContentLoaded", () => {
  const viewer = document.getElementById("product-model-viewer");
  const toggleBtn = document.getElementById("measurementToggle");
  const dimensionOverlay = document.querySelector(".dimension-overlay");

  if (!viewer || !toggleBtn || !dimensionOverlay) {
    console.warn("❌ Dimension toggle elements missing");
    return;
  }

  // Initial state (when 3D opens)
  let dimensionsVisible = false;

  // Hide dimensions initially
  dimensionOverlay.style.display = "none";
  viewer.autoRotate = true;

  toggleBtn.addEventListener("click", () => {
    dimensionsVisible = !dimensionsVisible;

    if (dimensionsVisible) {
      // 🔴 SHOW DIMENSIONS
      dimensionOverlay.style.display = "block";

      // viewer.autoRotate = false; // stop rotation
      // viewer.removeAttribute("auto-rotate");

      toggleBtn.textContent = "Hide dimensions";
    } else {
      // 🟢 HIDE DIMENSIONS
      dimensionOverlay.style.display = "none";

      // viewer.autoRotate = true; // resume rotation
      // viewer.setAttribute("auto-rotate", "");

      toggleBtn.textContent = "Show dimensions";
    }
  });
});

